import { IconExplore, TextButton, Tooltip } from '@swaggerhub-portal/component-library'
import { useTranslation } from 'react-i18next'

import { useUser } from '~/hooks/useUser'
import { SHUBApiDetails } from '~/types/api'

interface ExploreButtonProps {
  exploreUrl?: string,
  SHUBApiDetails: SHUBApiDetails
}
  
export const ExploreButton = ({ exploreUrl, SHUBApiDetails }: ExploreButtonProps) => {
  const { t } = useTranslation()
  const { isLoggedIn } = useUser()

  if (!exploreUrl) {
    return null
  }

  return (
    <Tooltip
      content={isLoggedIn ? t('components.ui.apiViewer.explore.tooltip.userLoggedIn') : t('components.ui.apiViewer.explore.tooltip.userNotLoggedIn')}
      trigger="hover"
      defaultComp={
        <a
          href={`${exploreUrl}/catalog?owner=${SHUBApiDetails?.orgName}&api=${SHUBApiDetails?.name}&version=${SHUBApiDetails?.version}`}
          target="_blank"
          rel="noreferrer" >
          <TextButton size="s" icon={<IconExplore />} className="!ml-0 duration-200 transition-color hover:!bg-neutral-80 hover:!text-neutral-00 dark:hover:bg-neutral-30 dark:hover:text-neutral-98">
            {t('components.ui.apiViewer.explore.label')}
          </TextButton>
        </a>
      }
      placement="bottom"
    />)
}